import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {ButtonUtils, InputButtonIconType} from '../button.utils';

@Component({
  selector: 'core-button-icon-big',
  templateUrl: 'button-icon-big.component.html',
  styleUrls: ['button-icon-big.component.scss']
})
export class ButtonIconBigComponent {

  @Input() id: string;

  @Input() type: InputButtonIconType;
  @Input() tooltipPosition: string = 'top';

  @Output() click = new EventEmitter<any>();

  constructor() {
    if (!this.id) {
      this.id = 'core-button-' + Math.random();
    }
  }

  getIconForType(type: InputButtonIconType): IconProp {
    return ButtonUtils.config.find(c => c.type === type).icon;
  }

  getClassForType(type: InputButtonIconType): string {
    return ButtonUtils.config.find(c => c.type === type).class + ' p-button-rounded core-button-icon-big';
  }

  getTooltipForType(type: InputButtonIconType): string {
    return ButtonUtils.config.find(c => c.type === type).tooltip;
  }

}
